var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyShipmentBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 221,
    viewBox: "0 0 168 221",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91 105.53L168 72.0298V187.03L91 220.53V105.53Z",
    fill: "#A9C9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M91 105.917L7.62939e-06 72.5298V187.143L91 220.53V105.917Z",
    fill: "#266EF1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82 46.5298L167.5 72.5296L90.4141 105.644L-0.000147199 72.5297L82 46.5298Z",
    fill: "#6DAAFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M56.9998 54.0297L141.32 83.9281L141.32 114.613L120.985 124.579L121.241 92.5644L34.9998 61.0297L56.9998 54.0297Z",
    fill: "#266EF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyShipmentBox);
export default __webpack_public_path__ + "static/media/empty-shipment-box.9edc305bd728b78e47ae861e1d41eb60.svg";
export { ForwardRef as ReactComponent };